import { Component, Input, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogModel, ButtonComponent } from 'wecheer-common';
import { ActionOperation, StepActionService } from '../step-action.service';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-step-actions',
  templateUrl: './step-actions.component.html',
  styleUrls: ['./step-actions.component.scss'],
  imports: [
    MatIconModule,
    ButtonComponent
]
})
export class StepActionsComponent {
  private stepAction = inject(StepActionService);
  private dialog = inject(MatDialog);


  @Input() strategy: any;
  @Input() parent: any;

  @Input() canAdd: boolean;
  @Input() canEdit: boolean;
  @Input() canDelete: boolean;


  onAddStep() {
    this.stepAction.triggerAdd({ operation: ActionOperation.Add, edited: this.strategy, parent: this.parent, original: this.strategy });
  }

  onEditStep() {
    this.stepAction.triggerEdit({ operation: ActionOperation.Edit, edited: this.strategy, parent: this.parent, original: this.strategy });
  }

  async onDeleteStep() {
    const confirmResult = await new ConfirmDialogModel('Are you sure you want to delete this step?').show(this.dialog);
    if (!confirmResult) return;

    this.stepAction.triggerDelete({ operation: ActionOperation.Delete, edited: this.strategy, parent: this.parent, original: undefined });
  }

}



